import { Component } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private router: Router,
    protected $gaService: GoogleAnalyticsService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (
        event instanceof NavigationEnd &&
        environment.NODE_ENV === 'production'
      ) {
        this.$gaService.pageView(event.url);
      }
    });
  }
}
